// extracted by mini-css-extract-plugin
export default {"button_container":"InnerButtonGroup_button_container__MiP4W","white_border":"InnerButtonGroup_white_border__lz0sc"};